import React from 'react';
import { useNavigate } from "react-router-dom";
import { Routes ,Route } from 'react-router-dom';
import Home from '../Components/Home/Home';
import Login from '../Components/Login/Login'
import CreateAccountPaper from '../Components/CreateAccount/CreateAccount';
import YourAccountComponent from '../Components/YourAccount/YourAccount';
import CheckoutComponent from '../Components/CheckoutComponent/CheckoutComponent';
import Orders from '../Components/OrdersComponent/OrdersComponent';
import UserOrdersComponent from '../Components/UserOrders/UserOrdersComponent';
import UserOrderComponent from '../Components/UserOrderComponent/UserOrderComponent';
import CompatibleProductsComponent from '../Components/CompatibleProducts/CompatibleProducts';
import { useParams
} from "react-router-dom";

function HomeComponentSearch(props) {
    let urlParams = useParams();
    return <React.Fragment>
                <Home {...props} urlParams={urlParams} />
            </React.Fragment>
}
function CreateAccount(props) {
    let urlParams = useParams();
    return <React.Fragment>
                <CreateAccountPaper {...props} urlParams={urlParams} />
            </React.Fragment>
}
function LoginPage(props) {
    let urlParams = useParams();
    return <React.Fragment>
                <Login {...props} urlParams={urlParams} />
            </React.Fragment>
}
function YourAccountPage(props) {
    let urlParams = useParams();
    return <React.Fragment>
                <YourAccountComponent {...props} urlParams={urlParams} />
            </React.Fragment>
}

function CheckoutPage(props) {
    let urlParams = useParams();
    return <React.Fragment>
                <CheckoutComponent {...props} urlParams={urlParams} />
            </React.Fragment>
}

function OrdersPage(props) {
    let urlParams = useParams();
    return <React.Fragment>
                <Orders {...props} urlParams={urlParams} />
            </React.Fragment>
}
function UserOrdersPage (props) {
    let urlParams = useParams();
    return <React.Fragment>
                <UserOrdersComponent {...props} urlParams={urlParams} />
            </React.Fragment> 
}
function UserOrderPage (props) {
    let urlParams = useParams();
    return <React.Fragment>
                <UserOrderComponent {...props} urlParams={urlParams} />
            </React.Fragment> 
}

function CompatibleProductsComponentPage (props) {
    let urlParams = useParams();
    return <React.Fragment>
                <CompatibleProductsComponent {...props} urlParams={urlParams} />
            </React.Fragment> 
}
export default function RouterSwitch(props) {
    function changeRoute(route) {
        document.location.href = route;
    }
    return (<Routes>
                <Route path="/" element={<HomeComponentSearch {...props} changeRoute={changeRoute} />} />
                <Route path="/create-account" element={<CreateAccount {...props} changeRoute={changeRoute} />} />
                <Route path="/page/:page" element={<HomeComponentSearch {...props} changeRoute={changeRoute} />} />
                <Route path="/search/:query" element={<HomeComponentSearch {...props} changeRoute={changeRoute} />} />
                <Route path="/search/:query/page/:page" element={<HomeComponentSearch {...props} changeRoute={changeRoute} />} />
                <Route path="/login" element={<LoginPage {...props} changeRoute={changeRoute} />} />
                <Route path="/your-account" element={<YourAccountPage {...props} changeRoute={changeRoute} />} />
                <Route path="/checkout" element={<CheckoutPage {...props} changeRoute={changeRoute} />} />
                <Route path="/orders" element={<OrdersPage {...props} changeRoute={changeRoute} />} />
                <Route path="/orders/page/:page" element={<OrdersPage {...props} changeRoute={changeRoute} />} />
                <Route path="/orders/page/:page/:query" element={<OrdersPage {...props} changeRoute={changeRoute} />} />
                <Route path="/orders/:query" element={<OrdersPage {...props} changeRoute={changeRoute} />} />
                <Route path="/user/orders/page/:page" element={<UserOrdersPage {...props} changeRoute={changeRoute} />}/>
                <Route path="/user/orders" element={<UserOrdersPage {...props} changeRoute={changeRoute} />} />
                <Route path="/user/order/:ordersID/:ordersSha" element={<UserOrderPage {...props} changeRoute={changeRoute} />} />
                <Route path="/compatible/products" element={<CompatibleProductsComponentPage {...props} changeRoute={changeRoute} />} />
                <Route path="/compatible/products/page/:page" element={<CompatibleProductsComponentPage {...props} changeRoute={changeRoute} />} />
                <Route path="/compatible/products/search/:query" element={<CompatibleProductsComponentPage {...props} changeRoute={changeRoute} />} />
                <Route path="/compatible/products/page/:page/search/:query" element={<CompatibleProductsComponentPage {...props} changeRoute={changeRoute} />} />
            </Routes>)
}